import client from '../utils/client';

export const getProduct = async (productId, params) => {
    return (await client('/apps/hb-cp/api/products/' + productId, {params})).product;
}

export const getCollection = async (params) => {
    return (await client('/apps/hb-cp/api/products/collections', {params})).collection;
}

export const getAddons = async (productId, params) => {
    return (await client('/apps/hb-cp/api/products/' + productId + '/addons', {params})).product_addons.products;
}

export const getBab = async (params) => {
    try {
        return (await client('/apps/hb-cp/api/products/bab', {params})).bab;
    }
    catch(err){
        alert('Opps, something went wrong. Please try again later.');
    }

}

export const getGifts = async (params) => {
    return (await client('/apps/hb-cp/api/products/bab/gifts', {params})).bab_gifts;
}

export const getGiftBoxes = async (params) => {
    return (await client('/apps/hb-cp/api/products/bab/gift-boxes',{
        params:{
            date: params?.date || new Date(),
        }
    })).bab_gift_boxes;
}

export const getBabAddons = async (params) => {
    return (await client('/apps/hb-cp/api/products/bab/addons', {params})).bab_addons.product_addons.products;
}

export const getBabTypes = async () => {
    return (await client('/apps/hb-cp/api/products/types?for=bab_gifts&published_status=published&status=active')).product_types;
}